<template>
  <div
    v-if="stepNav == 'ANSWER'"
    class="tab-pane fade show active"
    id="answer"
    role="tabpanel"
    aria-labelledby="nav-answer"
  >
    <AnsweredForms
      :resident_id="resident_id"
      button_answer
      v-on:update="$emit('update')"
      v-on:delete="$emit('delete')"
    />
  </div>
</template>

<script>
import AnsweredForms from "./Semiology/AnsweredForms";

import routes from "../../routes";

export default {
  name: "Semiology",
  components: {
    AnsweredForms,
  },
  data() {
    return {
      stepNav: "ANSWER",
      step: "FORMS",
      resident_id: "",
      form: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;
    },
  },
};
</script>
